require('./Resources/js/angular/module');
require('./Resources/js/angular/controllers/PitchActivityCtrl');
require('./Resources/js/angular/controllers/PitchLandingCtrl');
require('./Resources/js/angular/controllers/PitchModalCtrl');
require('./Resources/js/angular/controllers/PitchModalFormCtrl');
require('./Resources/js/angular/controllers/PitchNoteCtrl');
require('./Resources/js/angular/controllers/PitchNoteModalFormCtrl');
require('./Resources/js/angular/controllers/PlaylistPitchCtrl');
require('./Resources/js/angular/directives/InjectScript');
require('./Resources/js/angular/services/Pitch');
require('./Resources/js/angular/services/PitchEditModal');
require('./Resources/js/angular/services/PitchEmailer');
require('./Resources/js/angular/services/PitchEmailModal');
require('./Resources/js/angular/services/PitchModal');
require('./Resources/js/angular/services/PitchNote');
require('./Resources/js/angular/services/PitchNoteModal');


// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/index.js